import { defineStore } from 'pinia';
import { loginService, phoneLoginService, logoutService, getMessageNum, getUserInfo, refreshToken } from '@/service/interface';
import CryptoJS from 'crypto-js';
import globalObj from '../utils/globalObj';

let router_store;
async function getRouterStore() {
    // 异步导入
    const { useRouterStore } = await import('@/stores/router');
    router_store = useRouterStore();
}
getRouterStore();

export const useUserStore = defineStore('user', {
    state: () => ({
        token: sessionStorage.getItem('token') || '',
        tokenId: sessionStorage.getItem('tokenId') || '',
        loginFlag: sessionStorage.getItem('loginFlag') === 'true' || false,
        userMsgNum: 0, //用户消息数量
        userName: sessionStorage.getItem('userName') || '', // 用户名称
        timer: null, // 登录循环计时器，如果登录，在页面存在期间，每隔10分钟进行一次刷新token的操作
    }),
    actions: {
        // MARK Service 账号密码登录
        service_login(param, callback) {
            loginService(param).then((response) => {
                if (response.isSuccess) {
                    this.setLoginInfo(response);
                    this.service_getMsgNum();
                    this.service_getUserInfo();
                    if (callback) callback(response, null);
                } else {
                    if (callback) callback(null, response.errMsg);
                }
            });
        },
        // MARK Service 验证码登录
        service_phone_login(param, callback) {
            phoneLoginService(param).then((response) => {
                if (response.isSuccess) {
                    this.setLoginInfo(response);
                    this.service_getMsgNum();
                    this.service_getUserInfo();
                    if (callback) callback(response, null);
                } else {
                    if (callback) callback(null, response.errMsg);
                }
            });
        },
        // MARK Service 退出登录
        service_logout(callback) {
            let headers = {
                Authorization: this.token,
            };
            logoutService({ headers }).then((response) => {
                if (response.isSuccess) {
                    this.clearSessionStorage();
                    this.$reset(); // 重置 store 状态
                    if (callback) callback(null);
                } else {
                    if (callback) callback(response.errMsg);
                }
            });
        },
        // MARK Service 获取用户未读消息数量
        service_getMsgNum(callback) {
            getMessageNum({ params: { type: 2 } }).then((response) => {
                if (response.isSuccess) {
                    this.userMsgNum = response.data;
                }
                if (callback) callback(response);
            });
        },
        // MARK Service 获取用户信息
        service_getUserInfo(callback) {
            getUserInfo().then((response) => {
                if (response.isSuccess) {
                    sessionStorage.setItem('userName', response.data.surname);
                    this.userName = sessionStorage.getItem('userName');
                }
                if (callback) callback(response);
            });
        },
        // MARK Service 刷新token
        service_refreshToken(e) {
            refreshToken({ token: e }).then((response) => {});
        },
        // MARK Check 检查用户信息
        check_userInfo() {
            if (this.router_path_check()) {
                // 检查链接中是否包含了登录信息, 如果有, 则无论本地是否有信息, 都按照链接中的登录信息登录
                this.clearLoginInfo();
                const tokenId_dec = decodeURIComponent(this.route.query.tokenId);
                const tokenId_aes = CryptoJS.AES.decrypt(tokenId_dec, globalObj.config.__login_token_enc);
                const tokenId = tokenId_aes.toString(CryptoJS.enc.Utf8);
                this.setLoginInfo({ token: tokenId, tokenId: tokenId });
                this.service_getMsgNum();
                this.service_getUserInfo();
                return;
            } else if ((this.token.length || this.tokenId.length) && this.loginFlag) {
                // 本地存有登录信息, 不在进行登录处理, 更新用户消息
                this.service_getMsgNum();
                if (!this.timer) this.timer_start();
                return;
            }

            // 如果没有任何用户信息, 则清除数据, 防止脏数据异常
            this.clearLoginInfo();
        },
        // MARK RouterPath  校验链接中是否包含账号信息
        router_path_check() {
            if (this.route && this.route.query && this.route.query.tokenId && this.route.query.tokenId.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        // MARK Login 登录失效, 清除登录信息
        clearLoginInfo() {
            this.clearSessionStorage();
            this.clearUserInfo();
            this.timer_stop();
        },
        // MARK Info 清除信息
        clearUserInfo() {
            this.userMsgNum = 0;
            this.token = '';
            this.tokenId = '';
            this.loginFlag = false;
        },
        // MARK SessionStorage 设置登录信息
        setLoginInfo(response) {
            this.token = response.token;
            this.tokenId = response.tokenId;
            this.loginFlag = true;
            sessionStorage.setItem('token', response.token);
            sessionStorage.setItem('tokenId', response.tokenId);
            sessionStorage.setItem('loginFlag', this.loginFlag);
            this.timer_start();
        },
        // MARK SessionStorage 清除信息
        clearSessionStorage() {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('tokenId');
            sessionStorage.removeItem('loginFlag');
            sessionStorage.removeItem('userName');
        },
        // MARK Timer 启动定时器开始进行循环刷新token
        timer_start() {
            if (this.timer) {
                this.timer_stop();
            }
            this.timer = setInterval(() => {
                if (this.token && this.token.length && this.loginFlag) {
                    this.service_refreshToken(this.token);
                } else if (this.tokenId && this.tokenId.length && this.loginFlag) {
                    this.service_refreshToken(this.tokenId);
                }
            }, 10 * 60 * 1000); // 10分钟
        },
        // MARK Timer 关闭定时器
        timer_stop() {
            clearInterval(this.timer);
            this.timer = null;
        },
    },
});
